(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqSection extends HTMLElement {
    constructor() {
      super();
      this._searchDebounce = null;
      this._currentFilter = null;
      this._currentSearch = '';
    }

    connectedCallback() {
      this.filterButtons = this.querySelectorAll('.faq-section__filter');
      this.items = this.querySelectorAll('.faq-section__item');
      this.questionButtons = this.querySelectorAll('.faq-section__question');
      this.searchInput = this.querySelector('.faq-section__search-input');
      this.searchClear = this.querySelector('.faq-section__search-clear');
      this.resultsCount = this.querySelector('.faq-section__results-count');
      this.emptyState = this.querySelector('.faq-section__empty');

      this._cacheOriginalText();

      const activeFilter = this.querySelector('.faq-section__filter.is-active');
      this._currentFilter = activeFilter ? activeFilter.dataset.filter : null;

      this._bindEvents();
      this._applyFilters();
    }

    _cacheOriginalText() {
      this.items.forEach((item) => {
        const q = item.querySelector('.faq-section__question-text');
        const a = item.querySelector('.faq-section__answer-inner');
        if (q && !q.dataset.originalHtml) q.dataset.originalHtml = q.innerHTML;
        if (a && !a.dataset.originalHtml) a.dataset.originalHtml = a.innerHTML;
      });
    }

    _bindEvents() {
      this.filterButtons.forEach((btn) => {
        btn.addEventListener('click', () => this._handleFilter(btn));
      });

      this.questionButtons.forEach((btn) => {
        btn.addEventListener('click', () => this._toggleItem(btn));
      });

      if (this.searchInput) {
        this.searchInput.addEventListener('input', (e) => {
          clearTimeout(this._searchDebounce);
          this._searchDebounce = setTimeout(() => this._handleSearch(e.target.value), 200);
        });
      }

      if (this.searchClear) {
        this.searchClear.addEventListener('click', () => this._clearSearch());
      }
    }

    _handleFilter(button) {
      this._currentFilter = button.dataset.filter;
      this.filterButtons.forEach((b) => {
        const active = b === button;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this._applyFilters();
    }

    _handleSearch(value) {
      this._currentSearch = (value || '').toLowerCase().trim();
      if (this.searchClear) {
        this.searchClear.classList.toggle('is-visible', this._currentSearch.length > 0);
      }
      this._applyFilters();
    }

    _clearSearch() {
      if (this.searchInput) this.searchInput.value = '';
      this._currentSearch = '';
      if (this.searchClear) this.searchClear.classList.remove('is-visible');
      this._applyFilters();
    }

    _applyFilters() {
      let visible = 0;

      this.items.forEach((item) => {
        const cats = (item.dataset.categories || '').split(',').filter(Boolean);
        const search = item.dataset.search || '';

        const matchesFilter =
          !this._currentFilter ||
          this._currentFilter === '__all__' ||
          cats.includes(this._currentFilter);

        const matchesSearch = !this._currentSearch || search.includes(this._currentSearch);

        const show = matchesFilter && matchesSearch;

        if (show) {
          item.classList.remove('is-hidden');
          visible++;
          this._applyHighlight(item);
        } else {
          item.classList.add('is-hidden');
          item.classList.remove('is-open');
          const q = item.querySelector('.faq-section__question');
          if (q) q.setAttribute('aria-expanded', 'false');
        }
      });

      this._updateResultsCount(visible);

      if (this.emptyState) {
        this.emptyState.classList.toggle('is-visible', visible === 0);
      }
    }

    _applyHighlight(item) {
      const q = item.querySelector('.faq-section__question-text');
      const a = item.querySelector('.faq-section__answer-inner');

      if (q && q.dataset.originalHtml !== undefined) {
        q.innerHTML = this._highlight(q.dataset.originalHtml);
      }
      if (a && a.dataset.originalHtml !== undefined) {
        a.innerHTML = this._highlight(a.dataset.originalHtml);
      }
    }

    _highlight(html) {
      if (!this._currentSearch) return html;
      // Skip highlighting if HTML is complex (avoid breaking tags).
      // Simple approach: wrap matches in text nodes only.
      const term = this._currentSearch.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(`(${term})`, 'gi');
      const wrapper = document.createElement('div');
      wrapper.innerHTML = html;
      this._highlightTextNodes(wrapper, regex);
      return wrapper.innerHTML;
    }

    _highlightTextNodes(node, regex) {
      const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null);
      const matches = [];
      let n;
      while ((n = walker.nextNode())) {
        if (regex.test(n.nodeValue)) matches.push(n);
        regex.lastIndex = 0;
      }
      matches.forEach((textNode) => {
        const frag = document.createDocumentFragment();
        const parts = textNode.nodeValue.split(regex);
        parts.forEach((p) => {
          if (regex.test(p)) {
            const span = document.createElement('span');
            span.className = 'faq-section__search-highlight';
            span.textContent = p;
            frag.appendChild(span);
          } else if (p) {
            frag.appendChild(document.createTextNode(p));
          }
          regex.lastIndex = 0;
        });
        textNode.parentNode.replaceChild(frag, textNode);
      });
    }

    _updateResultsCount(count) {
      if (!this.resultsCount) return;
      if (this._currentSearch) {
        this.resultsCount.textContent = `${count} ${count === 1 ? 'result' : 'results'} for "${this._currentSearch}"`;
        this.resultsCount.classList.add('is-visible');
      } else {
        this.resultsCount.classList.remove('is-visible');
      }
    }

    _toggleItem(button) {
      const item = button.closest('.faq-section__item');
      if (!item) return;
      const isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open', !isOpen);
      button.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
    }
  }

  if (!customElements.get('faq-section')) {
    customElements.define('faq-section', FaqSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
